import { NgModule } from "@angular/core"
import { PlanFormComponent } from "./plan-form.component"
import { CommonModule } from "@angular/common"
import { FormsModule } from "@angular/forms"
import { PlanPagePicker } from "./plan-page-picker.component"
import { ModalModule } from "../modal/modal.module"
import { RouterModule } from "@angular/router"
import { KeepHtmlModule } from "src/pipes/keep-html/keep-html.module"
import { PopoverModule } from "ngx-bootstrap/popover"
import { VideoPlanFormComponent } from './video-plan-form.component'

@NgModule({
  declarations: [
    PlanFormComponent,
    PlanPagePicker,
    VideoPlanFormComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ModalModule,
    RouterModule,
    PopoverModule,
    KeepHtmlModule,
  ],
  exports: [
    PlanFormComponent,
    PlanPagePicker,
    VideoPlanFormComponent
  ]
})
export class PlanFormModule {}
